import { useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IUseFeaturesFormAdministradora {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFeaturesFormAdministradora = ({ setOpenModal }: IUseFeaturesFormAdministradora) => {
  const { valuesInputsAdministradora } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const { setAttTable, attTable, idTable, id } =
    useConfigPageContext();

  const handleCreate = async () => {
    if (!valuesInputsAdministradora.name?.trim())
      return handleGetAlert({ message: `Digite um nome de administradora` });

    setLoading(true);

    return api
      .post("/comissoes/administradoras/create", valuesInputsAdministradora)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!valuesInputsAdministradora.name?.trim())
      return handleGetAlert({ message: `Digite um nome de administradora` });

    setLoading(true);

    return api
      .put(`/comissoes/administradoras/${id}`, valuesInputsAdministradora)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (idTable) {
      handleEdit();
    } else {
      handleCreate();
    }
  };

  return { handleSubmit, loading };
};
